.legend {
	padding: calc(var(--jpo-common-base-spacing) * 2);
	border-top: 1px solid var(--ds-border, var(--adg3-color-N50));
}

.title {
	text-transform: uppercase;
	margin-bottom: calc(var(--jpo-common-base-spacing) * 2);
}

.content {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	column-gap: 80px;
	row-gap: 30px;
	align-items: flex-start;
}

.footer {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	margin-top: 20px;
	margin-bottom: 10px;
}

.legendContainer {
	display: flex;
	flex-direction: row;
}

.legendTitle {
	color: var(--ds-text-subtlest, var(--jpo-text-secondary-color));
	font-size: 14px;
	text-transform: none;
	font-weight: normal;
	margin-right: var(--jpo-common-base-spacing);
	line-height: 24px;
	vertical-align: middle;
	font-family: BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans',
		'Droid Sans', 'Helvetica Neue', sans-serif;
}

.legendItems {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}

.legendItem {
	display: flex;
	align-items: center;
	margin-right: calc(var(--jpo-common-base-spacing) * 2);
	margin-bottom: var(--jpo-common-base-spacing);
}

.legendItemIcon {
	width: 16px;
	height: 16px;
	margin-right: 4px;
}

.legendItemColor {
	width: 16px;
	height: 16px;
	margin-right: 4px;
	border-radius: 1px;
}

.legendItemText {
	line-height: 24px;
}

.systemIcon {
	display: flex;
	align-items: center;
	margin-right: 4px;
}

.changeIndicatorContainer {
	display: flex;
	position: relative;
	width: 16px;

	&.triangle {
		margin-top: -15px;
		margin-right: 8px;
	}

	&.bar {
		width: 8px;
		height: 16px;
	}
}
